import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PackingProcess } from '../models/entities/packing-process';
import { PackingProcessRequest } from '../models/dto/packing-process-request';



@Injectable({
  providedIn: 'root'
})
export class PackingProcessService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }

  
  //-----------------------------------------------------------------------------------------------------
  packingProcesssGet()  : Promise<PackingProcess[]> {
    let request     : BaseRequest = new BaseRequest(this.userService.userInfo);
    
    return new Promise((resolve, reject) => {
        this.networkService.post('packing/packingProcesssGet', request).then(result => {
          return resolve(result.packingProcesss);
        }, error => {
            reject(error);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------
  packingProcessGet(packingProcessId : number, branchId? : number)  : Promise<PackingProcess> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.id        = packingProcessId;
    request.lngArg1   = branchId

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingProcessGet', request).then(result => {
          return resolve(result.packingProcess);
        }, error => {
            reject(error);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------

  
  //-----------------------------------------------------------------------------------------------------
  packingProcessSave(packingProcess : PackingProcess) : Promise<PackingProcess> {
    let request           : PackingProcessRequest = new PackingProcessRequest(this.userService.userInfo);
    
    request.packingProcess = packingProcess;

    return new Promise((resolve, reject) => {
      this.networkService.post('packing/packingProcessSave', request).then(result => {
          let packingProcess : PackingProcess = result.packingProcess;
          return resolve(packingProcess);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------



}


